// extracted by mini-css-extract-plugin
module.exports = {"container":"Result-module--container--2-Jjl","header":"Result-module--header--1qH9I"};